import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const STATUS_COLORS: Record<string, { bg: string; text: string; ring: string }> = {
  Pending: { bg: 'bg-amber-100', text: 'text-amber-800', ring: 'ring-amber-200' },
  'In Progress': { bg: 'bg-blue-100', text: 'text-blue-800', ring: 'ring-blue-200' },
  'Awaiting Parts': { bg: 'bg-orange-100', text: 'text-orange-800', ring: 'ring-orange-200' },
  'Follow-up Visit Required': { bg: 'bg-yellow-100', text: 'text-yellow-800', ring: 'ring-yellow-200' },
  'Ready to Invoice': { bg: 'bg-purple-100', text: 'text-purple-800', ring: 'ring-purple-200' },
  Completed: { bg: 'bg-emerald-100', text: 'text-emerald-800', ring: 'ring-emerald-200' },
  Invoiced: { bg: 'bg-slate-200', text: 'text-slate-700', ring: 'ring-slate-300' },
  Cancelled: { bg: 'bg-red-100', text: 'text-red-800', ring: 'ring-red-200' },
};

export function statusColor(status: string) {
  return STATUS_COLORS[status] || { bg: 'bg-slate-100', text: 'text-slate-700', ring: 'ring-slate-200' };
}

export function initials(name?: string) {
  if (!name) return '?';
  const parts = name.trim().split(/\s+/);
  return (parts[0]?.[0] || '') + (parts[1]?.[0] || '');
}

export function isJobMine(job: { assigned_to?: string }, user: { username?: string; full_name?: string } | null) {
  if (!user) return false;
  const target = (job.assigned_to || '').toLowerCase().trim();
  const un = (user.username || '').toLowerCase().trim();
  const fn = (user.full_name || '').toLowerCase().trim();
  if (!target) return false;
  return target === un || target === fn || target.includes(un) || (fn && target.includes(fn));
}
